export enum UserDispatcherListRequestOrder {
  FIRST_NAME_ASC = "FIRST_NAME_ASC",
  FIRST_NAME_DESC = "FIRST_NAME_DESC",
  LAST_NAME_ASC = "LAST_NAME_ASC",
  LAST_NAME_DESC = "LAST_NAME_DESC",
  USERNAME_ASC = "USERNAME_ASC",
  USERNAME_DESC = "USERNAME_DESC",
}

export enum UserDispatcherListRequestStatusCriteria {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  ALL = "ALL",
}

export type UserDispatcherListRequestQueryParams = {
  cargoCompany?: string;
  cargoCompanyId?: string;
  dispatch?: string;
  dispatchId?: string;
  order?: UserDispatcherListRequestOrder;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserDispatcherListRequestStatusCriteria;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
};

type UserDispatcherListRequest = {
  cargoCompany?: string;
  cargoCompanyId?: string;
  dispatch?: string;
  dispatchId?: string;
  order?: UserDispatcherListRequestOrder;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserDispatcherListRequestStatusCriteria;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
};

export default UserDispatcherListRequest;
